const AccountConstants = {
    type: {
        ALL: 'all',
        BUSINESS: 'sales',
        SYSTEM_ADMINISTRATION: 'super',
        ACCOUNTANT: 'accountant',
    },
    status: {
        ALL: 'all',
        IS_ACTIVE: 'active',
        LOCKED: 'inactive',
    },
};
export const convertValueAccountStatus = (status: string) => {
    switch (status) {
        case AccountConstants.status.ALL:
            return 'Tất cả';
        case AccountConstants.status.IS_ACTIVE:
            return 'Đang hoạt động';
        case AccountConstants.status.LOCKED:
            return 'Đã khóa';
        default:
            return '';
    }
};
export const convertValueAccountType = (status: string) => {
    switch (status) {
        case AccountConstants.type.ALL:
            return 'Tất cả';
        case AccountConstants.type.BUSINESS:
            return 'Kinh doanh';
        case AccountConstants.type.SYSTEM_ADMINISTRATION:
            return 'Quản trị hệ thống';
        case AccountConstants.type.ACCOUNTANT:
            return 'Kế toán';
        default:
            return 'Khách hàng';
    }
};
export default AccountConstants;
